import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GlobalMapService {

  private _map$ = new Subject<google.maps.Map>();
  private _visible$ = new Subject<boolean>();
  private _visible: boolean = false;
  private _map: google.maps.Map;

  get visible$(): Observable<boolean> {
    return this._visible$.asObservable();
  }

  set visible(value: boolean) {
    this._visible$.next(value);
    this._visible = value;
  }

  get visible(): boolean {
    return this._visible;
  }

  get map(): google.maps.Map {
    return this._map;
  }

  set map(value: google.maps.Map) {
    this._map = value;
    this._map$.next(value);
  }

  get map$(): Observable<google.maps.Map> {
    return this._map$.asObservable();
  }

  constructor() {
  }

}
